import * as React from 'react';
import type { SVGProps } from 'react';
const SvgKeyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <mask
      id="a"
      width={16}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path fill="#currentColor" d="M0 0h16v16H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="currentColor"
        d="M4.8 9.6a1.54 1.54 0 0 1-1.13-.47A1.54 1.54 0 0 1 3.2 8q0-.66.47-1.13A1.54 1.54 0 0 1 4.8 6.4q.66 0 1.13.47T6.4 8t-.47 1.13a1.54 1.54 0 0 1-1.13.47m0 2.4q-1.667 0-2.833-1.167Q.8 9.667.8 8t1.167-2.833T4.8 4q1.083 0 2 .542.917.54 1.467 1.458h5.485q.131 0 .24.05a.7.7 0 0 1 .191.133l1.384 1.384a.5.5 0 0 1 .125.2.7.7 0 0 1 .041.236q0 .12-.05.225a.7.7 0 0 1-.133.189l-2.18 2.052a.5.5 0 0 1-.187.114 1.3 1.3 0 0 1-.2.05.4.4 0 0 1-.2-.016.6.6 0 0 1-.183-.1l-1-.717-.833.7a.57.57 0 0 1-.37.133.8.8 0 0 1-.197-.025.5.5 0 0 1-.183-.091L8.8 9.6h-.333a3.32 3.32 0 0 1-1.425 1.767A4.2 4.2 0 0 1 4.8 12m0-1.2q1.053 0 1.851-.675.8-.675.916-1.725H9.2l1.167.867 1.183-.984 1.35.967 1.367-1.267L13.5 7.2H7.483a3.1 3.1 0 0 0-1.041-1.442A2.62 2.62 0 0 0 4.8 5.2a2.7 2.7 0 0 0-1.983.817A2.7 2.7 0 0 0 2 8a2.7 2.7 0 0 0 .817 1.983A2.7 2.7 0 0 0 4.8 10.8"
      />
    </g>
  </svg>
);
export default SvgKeyIcon;
